import React from "react";
import { FaRegCompass, FaShieldAlt, FaSlidersH } from "react-icons/fa";
import card2Bg from "../../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../../assets/Bulk/Card2/card3.svg";
import card1Bg from "../../../assets/Exactness/Header/Bg.svg";

const cardData = [
  {
    title: "One-Click Email Retrieval",
    description:
      "Get verified emails directly from any LinkedIn profile. Simply click the extension to find email.",
    actionText: "Domain Search",
    icon: <FaRegCompass className="text-[#39C4DC] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#39C4DC]",
    bgcolor: "bg-[#EBFBFC]",
    border: "border-[#99E1ED]",
  },
  {
    title: "Simple to Use",
    description:
      "User-friendly interface that anyone can use , no tech skills needed. Find emails without the learning curve.",
    actionText: "Campaigns",
    icon: <FaShieldAlt className="text-[#F88DA0] text-xl" />,
    bgImage: card2Bg,
    color: "text-[#F88DA0]",
    bgcolor: "bg-[#FDEBED]",
    border: "border-[#F9AFBB]",
  },
  {
    title: "Always Up-to-Date",
    description:
      "We verify emails in real-time, so you know they'll actually reach your contacts.",
    actionText: "Integrations",
    icon: <FaSlidersH className="text-[#64D1AE] text-xl" />,
    bgImage: card3Bg,
    color: "text-[#64D1AE]",
    bgcolor: "bg-[#EBFBF4]",
    border: "border-[#98E2C9]",
  },
];

const Card = () => {
  return (
    <div className="grid gap-6 pb-16 bg-gray-50 sm:grid-cols-2 min-[950px]:grid-cols-3 p-6">
      {cardData.map((card, index) => (
        <div
          key={index}
          className={`relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left ${
            index === 2 ? "sm:col-span-2 min-[950px]:col-span-1 sm:mx-auto" : ""
          }`}
          style={{
            backgroundImage: `url(${card.bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-white opacity-5"></div>
          <div className="relative z-10 flex flex-col h-full">
            <div
              className={`my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 ${card.border} border ${card.bgcolor}`}
            >
              <div className="my-4">{card.icon}</div>
            </div>
            <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
            <p className="text-gray-600 mb-4">{card.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Card;
